if (typeof JW === 'undefined') JW = {};
JW.Map = (function ($)
{
    var _pri = {opts:{}};
    var publ = {};

    _pri.cname  = 'MAP';
    _pri.inited = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.initVals = function()
    {
        _pri.opts = $.extend(_pri.opts,
                    {
                        atk: ''
                    });


        _pri.page = null;

        _pri.mid =          'jobery.2658d8fe';      // mapbox map variant id
        _pri.mb_style_url = 'mapbox://styles/jobery/ciqmxpdk8001mc0m74y6uw1ig';
        _pri.map_format   = '.png32';               // mapbox map format: jpg70 jpg80 ... (with dot! because you may want to prefix for mat with @2x i.e. @2x.png)
        _pri.map_hdpi     = '';                     // fill with @2x for high dpi devices

        _pri.$map = null;                   // div
        _pri.map = null;                    // L.map obj
        _pri.tile_layer = null;             // map tiles

        _pri.mcg = null;                    // L.markerClusterGroup obj
        _pri.marker_layer = null;           // not used for now in favour of mcg
        _pri.marker_list = [];              // used for bulk adding markers
        _pri.marker_map = {};
        _pri.marker_pop_up = null;
        _pri.spiderfied_layers = [];

        _pri.sphere_mask = null;            // tile layer canvas to draw search radius mask
        _pri.dist_circle = null;            // the dashed outline
        _pri.dist_circle_ll = null;         // circles's center latLng
        _pri.dist_circle_bnds = null;       // bounds
        _pri.circle_marker = null;          // home / search center marker

        _pri.pop_up_over_tpl = '<div class="puo-cmp">{CMP_NAME}</div><div class="puo-loc m-b-5 small-notice">{ZIP} {CITY}</div>';
        _pri.pop_up_tpl = ''; //'<div class="puc"><a href="#" class="close-pu btn btn-primary"><i class="fa fa-times" aria-hidden="true"></i></a> <div class="pu-ttl mb-1"><h5><a href="{JOBS_LNK}" title="Ausbilderprofil">{CMP_NAME}</a></h5></div><div id="rpu-{ID}">{LOGO}</div><div class="small-notice">{ZIP} {CITY}, {STREET} {STREET_NO}</div><div class="pu-jbs"><h5 class="text-primary">{PROFILSEITEN}</h5><div class="pu-jbs-list">{JOBS}</div></div></div>';
        _pri.pop_up_home_html = '<a href="#" class="close-pu btn btn-primary"><i class="fa fa-times" aria-hidden="true"></i></a> <h5 class="pb-3">Suchbereich ändern</h5> <div class="pb-3">Dieses Icon markiert den Ausgangspunkt Ihrer Suche. Sie können dieses Icon verschieben, um den Suchbereich zu ändern.</div>';
        _pri.pu_open = false;

        _pri.$cont = null;

        _pri.r_mx = 60;

        _pri.do_resize = false;

        _pri.$map  = $('#map');
        _pri.$cont = $('#col-map');
    };

    publ.init = function()
    {
        _pri.dbgG('******** init()');

        if (_pri.inited)
        {
            _pri.dbgB('    already inited');
            // return;
        }

        _pri.initVals();

        _pri.page = JW.Page;

        if (_pri.$map.length == 0)
        {
            _pri.dbg('    no #map - exit');
            _pri.$map = null;
            return;
        }

        if (typeof window.devicePixelRatio !== 'undefined' && window.devicePixelRatio > 1.5)
        {
            _pri.map_hdpi = '@2x';
        }

        _pri.initOpts();
        _pri.initTpls('#wrp_map_tpls');
        _pri.pop_up_tpl = publ.getTpl('pop_up_tpl');

        _pri.initMap();

        _pri.inited = true;
    };

    _pri.initMap = function()
    {
        _pri.dbgG('*** initMap()');

        _pri.map = L.map('map', _pri.opts.map);
        _pri.map.setView([51.309155, 10.217285], 7);
        // _pri.tile_layer = L.tileLayer('https://{s}.tiles.mapbox.com/v4/' + _pri.mid + '/{z}/{x}/{y}' + _pri.map_hdpi + _pri.map_format + '?access_token=' + _pri.opts.atk, _pri.opts.tile_layer);
        _pri.tile_layer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + _pri.opts.atk, _pri.opts.tile_layer);
        _pri.tile_layer.addTo(_pri.map);

        //_pri.map.on('moveend', _pri.onMoveEnd);
        //_pri.map.on('zoomend', _pri.onZoomEnd);
        //_pri.map.on('load', _pri.mapOnLoad); // only fired when first time centered - already done here

        L.control.zoom(_pri.opts.control_zoom).addTo(_pri.map);
        L.control.fullscreen(_pri.opts.control_fullscreen).addTo(_pri.map);
        L.Control.scaleDl(_pri.opts.control_scale).addTo(_pri.map);
        //L.control.locate().addTo(_pri.map);
        //L.control.coordinates(_pri.opts.control_coordinates).addTo(_pri.map);

        /* *1 maybe ...
        _pri.marker_pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over);
        _pri.marker_pop_up.setLatLng(_pri.map.getCenter());
        _pri.map.addLayer(_pri.marker_pop_up);
        */

        _pri.mcg = L.markerClusterGroup(_pri.opts.mcg);

        if (JW.Page.isMobile())
        {
            _pri.mcg.on('click', _pri.popUpClick);
        }
        else
        {
            _pri.mcg.on('mouseover', function(e) {
                if (!_pri.pu_open)
                {
                    //_pri.dbg('e', e);
                    // _pri.marker_pop_up.setContent(e.layer.options.pu_content);
                    // _pri.marker_pop_up.setLatLng(e.latlng);
                    // _pri.marker_pop_up.update();
                    // _pri.map.openPopup(_pri.marker_pop_up); // *1

                    //_pri.dbg('marker ' + e.layer.options.title);

                    var pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over)
                        //.setContent(e.layer.options.pu_content)
                        .setContent(_pri.getPopUpOverContent(e.layer.options.job_obj))
                        .setLatLng(e.latlng)
                        .openOn(_pri.map);
                    //_pri.dbg('pop_up', pop_up);

                    //var $rdiv = $('#rpu-' + e.layer.options.job_obj[0]);
                    //$rdiv.find('input').rating(_pri.opts.list_rating);
                }
            });

            _pri.mcg.on('mouseout', function(e) {
                if (!_pri.pu_open)
                {
                    _pri.map.closePopup();
                }
            });

            _pri.mcg.on('click', function (e) {
                _pri.popUpClick(e);
                _pri.pu_open = true;
            });

            _pri.map.on('popupclose', function(e) {
                //_pri.dbg('close PopUp');
                _pri.pu_open = false;
            });
        }




        /*
        _pri.mcg.on('clusterclick', function (a) {
            // a.layer is actually a cluster
            _pri.dbg('cluster childs:', a.layer.getAllChildMarkers().length);
        });

        _pri.mcg.on('spiderfied', function(e) {
            _pri.dbg('mcg on spiderfied', e);
        });

        _pri.mcg.on('unspiderfied', function(e) {
            _pri.dbg('mcg on unspiderfied', e);
        });
        */

        /*WIP add methods spiderfyMultiple unspiderfyMultiple to markercluster src
        _pri.mcg.on('animationend', function(e) {
            _pri.dbg('mcg on animationend', e);
            _pri.dbg('mcg on animationend', e.target._zoom);
            if (e.target._zoom == e.target._maxZoom)
            {
                if (_pri.mcg.options.zoom_last_animation != e.target._maxZoom)
                {
                    _pri.mcg.options.zoom_last_animation = e.target._maxZoom;
                    //_pri.dbg('layers length: ', _pri.mcg);
                    _pri.map.eachLayer(function(layer) {     //iterate over map rather than clusters
                        _pri.dbg('+');
                        if (layer.getChildCount)
                        {         // if layer is markerCluster
                            _pri.dbg(layer._childCount);  // return count of points within each cluster
                            layer.spiderfy();
                            _pri.spiderfied_layers.push(layer);
                        }
                    });
                }
            }
            else
            {
                if (_pri.mcg.options.zoom_last_animation == e.target._maxZoom)
                {
                    var len = _pri.spiderfied_layers.length;
                    var i;
                    for (i = 0; i < len; ++i)
                    {
                        _pri.spiderfied_layers[i].unspiderfy();
                    }
                    _pri.spiderfied_layer = [];
                }
                _pri.mcg.options.zoom_last_animation = e.target._zoom;
            }
        });
        */

        _pri.map.addLayer(_pri.mcg);

        // without marker cluster:
        //_pri.marker_layer = L.layerGroup();
        //_pri.map.addLayer(_pri.marker_layer);

        _pri.sphere_mask = L.TileLayer.canvasSphereMask(_pri.opts.sphere_mask);



        /*
        var i, rndm0, rndm1;
        var points = [];
        for (i = 0; i < 0; ++i)
        {
           rndm0 = Math.random() * 3;
           rndm1 = Math.random() * 3;
           points.push([(50 + rndm0), (9 + rndm1)]);
        }
        points.push([53.27456, 10.12092]);
        _pri.dbg('points', points);
        */

        //TODO only init events not bound to elements if _pri.inited == false
        // events MapSForm

        _pri.page.on('sform:loading_jobs', function(e) {
            // start loading indicator
        });

        _pri.page.on('sform:loading_jobs_done', function(e, o) {
            // stop loading indicator
            //_pri.dbg('e', e);
            //_pri.dbg('o.key', o.key);
            _pri.setJobs(o.key);
        });

        // events geoc

        _pri.page.on('geoc:set_name_to_ll', function(e, o) {
            //_pri.dbg('on geoc:set_name_to_ll', o);
        });

        _pri.page.on('geoc:set_ll_to_name_done', function(e, o) {
            //_pri.dbg('on geoc:set_ll_to_name_done', o);
            _pri.setCircleSearch(o.ll, false, true);
        });

        _pri.page.on('sform:formSubmit_for_ll', function(e, ll) {
            //_pri.dbg('on sform:formSubmit_for_ll', ll);
            _pri.fitMapToCircle();
        });

        _pri.page.on('map_list:loc_click', function(e, id) {
            _pri.dbg('*** on map_list:loc_click', id);
            _pri.showMarker(id);
        });

        _pri.page.on('modal:get', function(e, o) {
            //_pri.dbg('on modal:get', o);
            if (_pri.map.isFullscreen() && typeof o === 'object' && typeof o.url !== 'undefined' && o.url === '/berufsfilm')
            {
                _pri.map.toggleFullscreen();
            }
        });

        $(document).on('click', '.close-pu', function(e) {
            e.stopPropagation();
            e.preventDefault();
            _pri.map.closePopup();
        });

        //JW.GeoC.locate();
        _pri.page.trigger('module:init_done', {mod: _pri.cname});
    };

    _pri.onMoveEnd = function(e)
    {
        //_pri.dbg('******** onMoveEnd()');
    };

    _pri.onZoomEnd = function(e)
    {
        //_pri.dbg('******** onZoomEnd()');
        //_pri.dbg(e);
    };

    _pri.popUpClick = function(e) {
        //_pri.dbg('e', e);
        //_pri.dbg('marker ' + e.layer.options.title);

        _pri.map.closePopup();

        var $cont = $(_pri.getPopUpContent(e.layer.options.job_obj));
        //_pri.dbg('$cont', $cont);

        $cont.find('input').rating(_pri.opts.list_rating);

        var pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over)
            .setContent($cont[0])
            .setLatLng(e.latlng)
            .openOn(_pri.map);
    };

    publ.showCol = function(bool)
    {
        //_pri.dbg('******** showCol(' + bool + ')');
        if (!_pri.$cont)
        {
            return;
        }

        if (!_pri.$cont.hasClass('d-none') == bool)
        {
            return;
        }

        if (bool)
        {
            _pri.map.closePopup();
            _pri.$cont.removeClass('d-none');
            if (_pri.do_resize)
            {
                _pri.do_resize = false;
                _pri.map.invalidateSize();
            }
        }
        else
        {
            _pri.$cont.addClass('d-none');
        }
    };

    publ.scheduleResize = function()
    {
        _pri.dbg('*** scheduleResize()');
        _pri.do_resize = true;
    };

    publ.resizeEvent = function()
    {
        //_pri.map.invalidateSize();
        _pri.map.closePopup();
    };

// ################################################################
// ################################################################
//         Context Menu
// ################################################################
// ################################################################


    _pri.cmShowCoordinates = function(e)
    {
        alert(e.latlng);
    };

    _pri.cmSearchHere = function(e)
    {
        //_pri.dbg('********* cmSearchHere()');
        //_pri.map.panTo(e.latlng);
        _pri.syncFormToLL(e.latlng);
        _pri.setCircleSearch(e.latlng);
    };

    _pri.cmZoomIn = function(e) {
        _pri.map.zoomIn();
    };

    _pri.cmZoomOut = function(e) {
        _pri.map.zoomOut();
    };


// ################################################################
// ################################################################
//         Geo Coding
// ################################################################
// ################################################################


    _pri.syncFormToCenter = function(e)
    {
        //_pri.dbg('******** syncFormToCenter()');
        if (_pri.isCircleUpd())
        {
            _pri.syncFormToLL(_pri.map.getCenter());
        }
    };

    _pri.syncFormToLL = function(ll)
    {
        //_pri.dbg('******** syncFormToLL()');

        JW.GeoC.getNameToLL(ll);
    };


// ################################################################
// ################################################################
//         Circle
// ################################################################
// ################################################################


    _pri.isCircleUpd = function(fit_bounds)
    {
        fit_bounds = typeof fit_bounds === 'undefined' ? false : fit_bounds;

        //_pri.dbg('********* isCircleUpd() should fit?', fit_bounds);

        var bnds = _pri.map.getBounds();
        if (_pri.dist_circle_bnds && (!fit_bounds && bnds.intersects(_pri.dist_circle_bnds) || (fit_bounds && bnds.contains(_pri.dist_circle_bnds))))
        {
            //_pri.dbg('         isCircleUpd() NO');
            return false;
        }
        //_pri.dbg('         isCircleUpd() YES');
        return true;
    };

    _pri.initCircleMarker = function(ll)
    {
        //_pri.dbg('********* initCircleMarker()');
        var icon = new HomeMarker({
            html: '<b>&nbsp;</b>'
        });
        var pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over).setContent(_pri.pop_up_home_html);

        _pri.circle_marker = new L.marker(ll, {icon: icon, draggable: true}).addTo(_pri.map);
        _pri.circle_marker.bindPopup(pop_up);
        _pri.circle_marker.setZIndexOffset(100000);
        _pri.circle_marker.on('dragend', function(e) {
            var ll = _pri.circle_marker.getLatLng();
            _pri.syncFormToLL(ll);
            _pri.setCircleSearch(ll);
        });
    };

    _pri.initCircle = function(ll, dist)
    {
        //_pri.dbg('********* initCircle()');
        _pri.dist_circle = L.circle(ll, (dist * 1000), _pri.opts.circle_path).addTo(_pri.map);
        _pri.dist_circle_ll = ll;
        _pri.dist_circle_bnds = _pri.dist_circle.getBounds();
        _pri.initCircleMarker(ll);
    };

    _pri.updCircle = function(ll, dist)
    {
        //_pri.dbg('********* updCircle()');
        _pri.dist_circle_ll = ll;
        _pri.dist_circle.setLatLng(ll);
        _pri.dist_circle.setRadius(dist * 1000);
        _pri.dist_circle_bnds = _pri.dist_circle.getBounds();
        _pri.circle_marker.setLatLng(ll);
    };

    publ.showCircleDist = function(dist)
    {
        //_pri.dbg('******** showCircleDist()');
        if (!_pri.map)
        {
            return;
        }

        var ll;

        if (_pri.dist_circle_ll === null)
        {
            ll = _pri.map.getCenter();
            _pri.initCircle(ll, dist);
        }
        else
        {
            _pri.updCircle(_pri.dist_circle_ll, dist);
        }
    };

    publ.setCircleDist = function(dist)
    {
        //_pri.dbg('******** setCircleDist()');
        if (!_pri.map)
        {
            return;
        }

        var ll;

        if (_pri.dist_circle_ll === null)
        {
            ll = _pri.map.getCenter();
            _pri.initCircle(ll, dist);
        }
        else if (_pri.isCircleUpd(true))
        {
            _pri.setCircleSearch(_pri.dist_circle_ll, dist);
        }
        else
        {
            _pri.setCircleSearch(_pri.dist_circle_ll, dist);
        }
    };

    _pri.setCircleSearch = function(ll, dist, force_fit)
    {
        //_pri.dbg('********* setCircleSearch()');

        dist = dist || JW.MapSForm.getDist();
        force_fit = force_fit || false;

        if (_pri.dist_circle == null)
        {
            _pri.initCircle(ll, dist);
        }
        else
        {
            _pri.updCircle(ll, dist);
        }

        if (!_pri.map.hasLayer(_pri.sphere_mask))
        {
            _pri.map.addLayer(_pri.sphere_mask);
        }

        _pri.sphere_mask.setSpheres([ll], dist * 1000);

        _pri.fitMapToCircle(force_fit);
    };

    _pri.fitMapToCircle = function(force_fit)
    {
        //_pri.dbg('********* fitMapToCircle()');

        force_fit = force_fit || false;
        if (!_pri.dist_circle_bnds)
        {
            return;
        }
        //getBoundsZoom
        if (!force_fit)
        {
            var mb = _pri.map.getBounds();
            z0 = _pri.map.getZoom();
            z1 = _pri.map.getBoundsZoom(_pri.dist_circle_bnds);

            if (!mb.intersects(_pri.dist_circle_bnds) || z0 < z1)
            {
                force_fit = true;
            }

        }

        if (force_fit)
        {
            //_pri.dbg('         yup! fit map');
            _pri.map.fitBounds(_pri.dist_circle_bnds);
        }
    };


// ################################################################
// ################################################################
//         Get Jobs
// ################################################################
// ################################################################


    _pri.setRMxBase = function(len)
    {
        var dis_at_zoom = 15;
        var r_mx = 60;

        if (len > 2048)
        {
            dis_at_zoom = 15;
            r_mx = 60;
        }
        else if (len > 1024)
        {
            dis_at_zoom = 14;
            r_mx = 55;
        }
        else if (len > 512)
        {
            dis_at_zoom = 13;
            r_mx = 50;
        }
        else if (len > 256)
        {
            dis_at_zoom = 12;
            r_mx = 45;
        }
        else if (len > 128)
        {
            dis_at_zoom = 11;
            r_mx = 40;
        }
        else if (len > 64)
        {
            dis_at_zoom = 10;
            r_mx = 35;
        }
        else if (len > 32)
        {
            dis_at_zoom = 9;
            r_mx = 30;
        }
        else
        {
            dis_at_zoom = 8;
            r_mx = 30;
        }

        _pri.r_mx = r_mx;
    };

    _pri.getRMx = function(z)
    {
        if (z >= 15)
        {
            return 12;
        }
        return _pri.r_mx;
    };

    _pri.setJobs = function(key)
    {
        //_pri.dbg('******** setJobs()');

        /* tried to prevent those leaflet errors ... but for now
        _pri.map.once("moveend", function() {
            _pri.dbg('    setJobs() once moveend catched');
        });
        */

        var ret = JW.MapSForm.getJobsToKey(key);
        //_pri.dbg(typeof ret);
        //_pri.dbg('jobs', ret);
        if (_pri.isObj(ret) && _pri.isObj(ret.jobs) && $.isArray(ret.jobs))
        {
            var icon, marker, i, o;
            var len = ret.jobs.length;

            _pri.setRMxBase(len);
            //_pri.dbg('len:', len, 'r_mx:', _pri.r_mx);
            _pri.mcg.clearLayers(); // calls _generateInitialClusters which updates disableClusteringAtZoom and maxClusterRadius
            _pri.marker_map = {};
            _pri.marker_list = [];

            for (i = 0; i < len; ++i)
            {
                var o = ret.jobs[i];

                if (o[4] == 0)
                {
                    icon = new DefMarker({
                        //html: '<b>' + (i + 1) + '</b>'
                        className:    'def-marker'
                    });
                }
                else
                {
                    if (o[20] == '')
                    {
                        icon = new TopMarker({
                            //html: '<b>' + (i + 1) + '</b>'
                            className:    'top-marker'
                        });
                    }
                    else
                    {
                        icon = new TopMarkerLogo({
                            //html: '<b>' + (i + 1) + '</b>'
                            className:    'top-marker-logo',
                            html: '<div class="img-frm"><img src="/img/live/hamma-ausbilder-marker.png" width="33"></div>'
                        });
                    }
                }

                marker = L.marker(L.latLng(o[2], o[3]), { icon: icon, job_obj: o, riseOnHover: false, riseOffset: 100000 });
                _pri.marker_list.push(marker);
                _pri.marker_map[o[0]] = marker;
            }

            /*
                0   b.id
                1   b.public_id
                2   b.lat
                3   b.lng
                4   b.prio
                5   b.name
                6   b.zip
                7   b.city
                8   b.street
                9   b.street_no
                10  b.ts_mod
                11  c.name
                12  c.legal
                13  c.dept
                14  rating
                15  c.rate_cnt
                16  c.public_id
                17  [j.public_id]
                18  [j.emp_title]
                19  [j.prof_video 0/1]
                20  logo 0/1
                21  distance
            */

            /*
            $.each(ret, function (ix, o) {
                icon = new DefMarker({
                    html: '<b>' + ix + '</b>'
                });

                // for type 1
                // new L.Icon.Default();
                // file format  id, emp_title, emp_zip, emp_city, emp_prof0, lat, lng FROM `".Job::TABLE_NAME."` ORDER BY `ts_add` DESC "; // LIMIT 0, 10";
                //0 : id
                //1 : lat
                //2 : lon
                //3 : emp_title
                //4 : emp_zip
                //5 : emp_city
                //6 : prio
                //7 : emp_prof0
                //8 : ts_add
                //9 : company name
                //10 : company legal
                //11 : company dept
                //12 : company rating
                //13 : company rate cnt
                //14 : cmp public_id rate cnt
                //15 : distance

                marker = L.marker(L.latLng(o[1], o[2]), { icon: icon, title: o[3], riseOnHover: true, riseOffset: 100000 });
                _pri.marker_list.push(marker);

            });
            */

            _pri.mcg.addLayers(_pri.marker_list);
        }
    };

    _pri.marker_hover = function(e)
    {
        //_pri.dbg(this.toGeoJSON());
        this.openPopup();
    };

    _pri.mcgChunkProgress = function(processed, total, elapsed, layersArray)
    {
        //_pri.dbg('******** JW.Map.mcgChunkProgress(): ' + Math.round(processed/total*100) + '%');
        if (elapsed > 1000)
        {
            // if it takes more than a second to load, display the progress bar:
            //progress.style.display = 'block';
            //progressBar.style.width = Math.round(processed/total*100) + '%';
        }

        if (processed === total)
        {
            // all markers processed - hide the progress bar:
            //progress.style.display = 'none';
        }
    };

    _pri.setMcgIcon = function(cluster)
    {
        var cnt = cluster.getChildCount();
        return L.divIcon({
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            className: 'jw-mcg-marker',
            html: cnt.toString()
        });
    };
    /*
    _pri.setMcgIcon = function(cluster)
    {
        var cnt = cluster.getChildCount();
        var sz = 'sm';
        if (cnt >= 100)
        {
            sz = 'lg';
        }
        else if (cnt >= 10)
        {
            sz = 'md';
        }
        return L.divIcon({
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            className: 'jw-cic-' + sz,
            html: cnt.toString()
        });
    };
    */
    _pri.showMarker = function(id)
    {
        _pri.dbg('*** showMarker() id:', id);

        if (typeof _pri.marker_map[id] !== 'undefined')
        {
            var m = _pri.marker_map[id];
            //_pri.dbg('marker:', m);
            //_pri.marker_map[id].trigger('mouseover');
            if (_pri.map.getZoom() < _pri.opts.show_marker_min_zoom) //!= _pri.opts.map.maxZoom)
            {
                _pri.mcg.once("animationend", function(e) {
                    //_pri.dbg('    after onece');
                    _pri.showMarkerPopup(m);}
                );
                _pri.map.setView(m.getLatLng(), _pri.opts.show_marker_min_zoom);//_pri.opts.map.maxZoom);
            }
            else
            {
                _pri.map.setView(m.getLatLng());//, _pri.opts.map.maxZoom);
                //_pri.dbg('    after');
                _pri.showMarkerPopup(m);
            }
        }
    };

    _pri.showMarkerPopup = function(m)
    {
        //_pri.dbg('    after once');

        var cluster = _pri.mcg.getVisibleParent(m);
        //_pri.dbg(cluster);
        if (cluster && cluster.getChildCount)
        {   // if cluster is markerCluster
            //_pri.dbg(cluster._childCount);  // return count of points within each cluster
            cluster.spiderfy();
            //_pri.spiderfied_layers.push(m);
        }
        /**/
        // on loc click open full pop_up, not only the hover pop_up
        if (true)
        {
            var $cont = $(_pri.getPopUpContent(m.options.job_obj));
            //_pri.dbg('$cont', $cont);

            $cont.find('input').rating(_pri.opts.list_rating);

            var pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over)
                .setContent($cont[0])
                .setLatLng(m.getLatLng())
                .openOn(_pri.map);
        }
        else
        {
            var pop_up = new L.PopUpDl(_pri.opts.pop_up_marker_over)
                .setContent(_pri.getPopUpOverContent(m.options.job_obj))
                .setLatLng(m.getLatLng())
                .openOn(_pri.map);
        }

        _pri.pu_open = true;
        /**/
    };

            /*
                0   b.id
                1   b.public_id
                2   b.lat
                3   b.lng
                4   b.prio
                5   b.name
                6   b.zip
                7   b.city
                8   b.street
                9   b.street_no
                10  b.ts_mod
                11  c.name
                12  c.legal
                13  c.dept
                14  rating
                15  c.rate_cnt
                16  c.public_id
                17  [j.public_id]
                18  [j.emp_title]
                19  [j.prof_video]
                20  c.logo
                21  distance
            */

    _pri.getPopUpContent = function(o)
    {
        _pri.dbg('**** getPopUpContent() o:', o);

        //'<div>' + o[3] + '</div><div><a class="job-lnk" id="job-lnk-' + o[0] + '" href="/job/' + o[0] + '" target="_blank">' + o[9] + ' ' + o[10] + (o[11] != '' ? ', ' + o[11] : '') + '</a></div><div>' + o[4] + ' ' + o[5] + '</div>';
        // var cmp_name = o[11] + ' ' + o[12] + (o[13] != '' ? '<br><small>' + o[13] : '</small>');
        // cmp_name += ('<br>' + o[5]);
        var cmp_name      = o[18];
        var rating_public = o[14].replace(/\./g, ',');
        var logo = o[20] == '' ? '' : '<img class="img-fluid" src="' + o[20] + '" alt="Logo: ' + o[11] + '" style="max-width:100% !important;max-height:100% !important">';
        var dtb  = o[19] == '' ? '' : '<div class="mt-3 card-text d-flex small-notice"><i class="fa fa-lg fa-calendar text-success pt-1 mr-2"></i>Zusätzliche persönliche Termin&shy;verein&shy;barungen zum Video-Chat auf der Profilseite möglich</div>';
        let hamma_icon = o[4] == '1' ? '<img class="stand-hamma-icon" src="/img/live/hamma-ausbilder2.png" width="56" height="56" alt="Hamma Ausbilder!">' : '';
        // var job_list = [];
        // var i, job_div;
        // for (i = 0; i < o[17].length; ++i)
        // {
        //     // <div><a href="/ausbildungsplatz/e579f3a76491377bff2ced56a12ae10d/c5c859d33b9755d42359066edaf449e9" target="_blank">Verfahrensmechaniker/-in für Kunststoff- und Kautschuktechnik </a> <a href="/berufsfilm" data-cpid="{CMP_PID}" class="ajx" title="Berufsfilm der Bundesagentur für Arbeit"> <i class="fa fa-pull-right fa-2x fa-youtube-play text-primary" aria-hidden="true"></i> </a></div>
        //     job_div_cont = '<a href="/live/' + o[17][i] + '">' + o[18][i] + '</a>';
        //     if (o[19][i] == '1')
        //     {
        //         job_div_cont += ' <a href="/berufsfilm" data-jpid="' + o[17][i] + '" class="ajx" title="Berufsfilm der Bundesagentur für Arbeit"> <i class="fa fa-pull-right fa-2x fa-youtube-play text-primary" aria-hidden="true"></i> </a>';
        //     }
        //     //job_list.push('<li><a href="/ausbildungsplatz/' + o[17][i] + '/' + o[1] + '" target="_blank">' + o[18][i] + '</a></li>');
        //     job_list.push('<div>' + job_div_cont + '</div>');
        // }
        // let listhdl = 'Profilseite:';
        // if (o[17].length > 1)
        // {
        //     listhdl = 'Profilseiten:';
        // }

        return _pri.pop_up_tpl
                .replace(/\{ID\}/g, o[0])
                .replace(/\{LS_LNK\}/g, o[17])
                .replace(/\{TITLE\}/g, o[3])
                .replace(/\{CMP_PID\}/g, o[16])
                .replace(/\{CMP_NAME\}/g, cmp_name)
                .replace(/\{LOGO\}/g, logo)
                .replace(/\{DISTANCE\}/g, 'Entfernung: ' + o[21] + ' km')
                // .replace(/\{PROFILSEITEN\}/g, listhdl)

                .replace(/\{ZIP\}/g, o[6])
                .replace(/\{CITY\}/g, o[7])
                .replace(/\{STREET\}/g, o[8])
                .replace(/\{STREET_NO\}/g, o[9])
                // .replace(/\{JOBS\}/g, job_list.join(''));
                .replace(/\{DTB\}/g, dtb)
                .replace(/\{HAMMA\}/g, hamma_icon);
    };

    _pri.getPopUpOverContent = function(o)
    {
        //'<div>' + o[3] + '</div><div><a class="job-lnk" id="job-lnk-' + o[0] + '" href="/job/' + o[0] + '" target="_blank">' + o[9] + ' ' + o[10] + (o[11] != '' ? ', ' + o[11] : '') + '</a></div><div>' + o[4] + ' ' + o[5] + '</div>';
        // var cmp_name = o[11] + ' ' + o[12] + (o[13] != '' ? ', ' + o[13] : '');
        // cmp_name += ('<br>' + o[5]);
        var cmp_name = o[18];

        return _pri.pop_up_over_tpl
                .replace(/\{TITLE\}/g, o[3])
                .replace(/\{CMP_NAME\}/g, cmp_name)
                .replace(/\{ZIP\}/g, o[6])
                .replace(/\{CITY\}/g, o[7]);
    };

    _pri.initOpts = function()
    {
        var opts = {
            map: {
                zoom: 8,
                minZoom: 3,
                maxZoom: 17,
                attributionControl: false,
                contextmenu: true,
                //contextmenuWidth: 140,
                closePopupOnClick: true,
                contextmenuItems: [
                    {
                        text: '<i class="fa fa-search fa-fw" aria-hidden="true"></i> Hier suchen',
                        callback: _pri.cmSearchHere
                    },
                    {
                        text: '<i class="fa fa-map-marker fa-fw" aria-hidden="true"></i> Koordinaten anzeigen',
                        callback: _pri.cmShowCoordinates
                    },
                    '-',
                    {
                        text: '<i class="fa fa-search-plus fa-fw" aria-hidden="true"></i> Ansicht vergrößern',
                        callback: _pri.cmZoomIn
                    },
                    {
                        text: '<i class="fa fa-search-minus fa-fw" aria-hidden="true"></i> Ansicht verkleinern',
                        callback: _pri.cmZoomOut
                    }
                ],
                maxBounds: [
                    [-90, -Infinity],
                    [90, Infinity]
                ],
                zoomControl: false,
                fullscreenControl: false
            },
            tile_layer: {
                // +++ new
                    // id: 'mapbox/streets-v11',
                    // id: 'jobery/ciqmxpdk8001mc0m74y6uw1ig',
                    // id:         'jobery/ckcp6y5lw06h21il9a6vc8mcl', // JW
                    id:         'jobery/ckcphzem80h0j1iqpndizd38v', // JW-bright
                    tileSize:   512,
                    zoomOffset: -1,
                // ---
                subdomains: 'abcd'
            },
            mcg: {
                chunkedLoading: true,
                chunkProgress: _pri.mcgChunkProgress,
                //disableClusteringAtZoom: 17,
                //removeOutsideVisibleBounds: true,  // def true
                //animate: false,                    // def true
                //singleMarkerMode: true,            // def false
                showCoverageOnHover: true,           // def true
                spiderfyOnMaxZoom: true,             // def true
                maxClusterRadius: _pri.getRMx, //60,               // def 80
                iconCreateFunction: _pri.setMcgIcon,
                //spiderfyDistanceMultiplier: 0.5,  // only needed if we force spiderfy all at max zoom
                spiderLegPolylineOptions: {
                    weight: 1.5,
                    color: '#48AEBF',
                    opacity: 0.3
                },
                polygonOptions: {
                    stroke: true,
                    color: '#FF6F00',
                    weight: 1.0,
                    opacity: 0.8,
                    fill: true,
                    fillColor: '#FF6F00',
                    fillOpacity: 0.2
                },
                zoom_last_animation: 0
            },
            control_zoom: {
                position: 'topleft',
                zoomInText: '',
                zoomOutText: '',
                zoomInTitle: 'Vergrößern',
                zoomOutTitle: 'Verkleinern'
            },
            control_fullscreen: {
                position: 'topleft'
            },
            control_scale: {
                imperial: false,
                maxWidth: 120
            },
            control_coordinates: {
                position: "bottomleft", //optional default "bootomright"
                decimals: 5, //optional default 4
                decimalSeperator: ".", //optional default "."
                labelTemplateLat: "Latitude: {y}", //optional default "Lat: {y}"
                labelTemplateLng: "Longitude: {x}", //optional default "Lng: {x}"
                enableUserInput: true, //optional default true
                useDMS: false, //optional default false
                useLatLngOrder: true, //ordering of labels, default false-> lng-lat
                markerType: L.marker, //optional default L.marker
                markerProps: {} //optional default {},
                //labelFormatterLng: function(lng){return lng+" lng"}, //optional default none,
                //labelFormatterLat: function(lat){return lat+" lat"}, //optional default none
                // customLabelFcn: function(latLonObj, opts) { "Geohash: " + encodeGeoHash(latLonObj.lat, latLonObj.lng)} //optional default none
            },
            circle_path: {
                color: '#FF6F00', //'#48AEBF', //'#333333', //'#FF6F00', //'#bf8348',
                weight: 3,
                opacity: 0.8, //1, //0.5,
                dashArray: '5, 5',
                fill: true,
                fillColor: '#48AEBF',
                fillOpacity: 0,
                //fillRule: 'nonzero',
                clickable: false
            },
            sphere_mask: {
                opacity: 0.1,
                radius: 10000, //35000, //10000, //25000
                bgcolor: '#48AEBF', //'#808080', //'#f5f5f5', //'rgba(72, 174, 191, .1)', //'#48AEBF',
                lineColor: '#FF6F00',
                lineWidth: 3
            },
            pop_up_marker_over: {
                offset: L.point(0, -40),
                closeButton: false,
                autoPan: false,
                className: 'pop-up-marker-over dvc-' + JW.Page.getDevice()
            },
            show_marker_min_zoom: 14,
            list_rating: {
                theme: '',
                emptyStar: '<i class="glyphicon glyphicon-star"></i>',
                language: 'de',
                displayOnly: true,
                size: 'xs'
            }
        };

        if ($('body').data('fsps'))
        {
            opts.control_fullscreen.pseudoFullscreen = true;
        }

        $.extend(_pri.opts, opts);
        _pri.opts.atk = JW.Page.getATk();
    };

// ################################################################
// ################################################################
//         Utils & Misc
// ################################################################
// ################################################################

    publ.tests = function()
    {
        /*
        var ll = L.latLng(51.9458, 7.9857);
        var p = _pri.map.project(ll,1);
        _pri.dbg(p);
        var p = _pri.map.project(ll,9);
        _pri.dbg(p);
        _pri.dbg('cur zoom:', _pri.map.getZoom());
        */

        /*
        _pri.dbg('ZOOM:', _pri.map.getZoom());
        var center = _pri.dist_circle.getLatLng();
        _pri.dbg(center);
        center.lat -= 0.001;
        _pri.dbg(center);
        _pri.dist_circle.setLatLng(center);
        */

        /*
        var m = L.marker([51.5, 10.5], {title: 'test'});
        m.bindPopup('TESCHT!');
        m.addTo(_pri.map);
        */


    };

    publ.getMapCenter = function()
    {
        if (!_pri.map)
        {
            return null;
        }
        return _pri.map.getCenter();
    }

    _pri.extend();
    // publ.init();

    // expose public methods
    return publ;
})(jQuery);